import type { ExpenseCostSplit } from '../../api';
import type { User } from '../../types';
import {
  ISSUE_PERFORMER_OPTIONS,
  performerNamePlaceholder,
  performerNeedsName,
  type MaintenancePerformerType,
} from '../../utils/aircraftMaintenance';
import { parseIssueCost } from '../../utils/issueDisplay';
import './IssueResolveFields.css';

type Props = {
  members: User[];
  performerType: MaintenancePerformerType;
  performerName: string;
  cost: string;
  costSplit: ExpenseCostSplit;
  payerUserId: number;
  onPerformerTypeChange: (value: MaintenancePerformerType) => void;
  onPerformerNameChange: (value: string) => void;
  onCostChange: (value: string) => void;
  onCostSplitChange: (value: ExpenseCostSplit) => void;
  onPayerUserIdChange: (value: number) => void;
  legacySplit?: boolean;
};

const IssueResolveFields = ({
  members,
  performerType,
  performerName,
  cost,
  costSplit,
  payerUserId,
  onPerformerTypeChange,
  onPerformerNameChange,
  onCostChange,
  onCostSplitChange,
  onPayerUserIdChange,
  legacySplit = false,
}: Props) => {
  const parsed = parseIssueCost(cost);
  const showSplit = parsed.ok && parsed.value > 0 && !legacySplit;

  return (
    <>
      <label>Кем устранена</label>
      <select
        value={performerType}
        onChange={(e) =>
          onPerformerTypeChange(e.target.value as MaintenancePerformerType)
        }
      >
        <option value="">Не указано</option>
        {ISSUE_PERFORMER_OPTIONS.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      {performerNeedsName(performerType) ? (
        <>
          <label>{performerNamePlaceholder(performerType)}</label>
          <input
            type="text"
            value={performerName}
            onChange={(e) => onPerformerNameChange(e.target.value)}
            maxLength={80}
            placeholder={performerNamePlaceholder(performerType)}
          />
        </>
      ) : null}

      <label>Стоимость, ₽</label>
      <input
        type="text"
        inputMode="decimal"
        autoComplete="off"
        value={cost}
        onChange={(e) => onCostChange(e.target.value)}
      />
      <p className="issue-resolve-hint">0 — устранение без расхода</p>

      {showSplit ? (
        <>
          <label>Тип расхода</label>
          <div className="issue-split-radios">
            <label>
              <input
                type="radio"
                name="issue-cost-split"
                checked={costSplit !== 'personal'}
                onChange={() => onCostSplitChange('shares')}
              />
              Долевая
            </label>
            <label>
              <input
                type="radio"
                name="issue-cost-split"
                checked={costSplit === 'personal'}
                onChange={() => onCostSplitChange('personal')}
              />
              Личная
            </label>
          </div>
          {costSplit === 'personal' ? (
            <>
              <label>Кто оплатит</label>
              <select
                value={payerUserId || ''}
                onChange={(e) =>
                  onPayerUserIdChange(Number(e.target.value) || 0)
                }
              >
                <option value="">Выберите участника</option>
                {members.map((member) => (
                  <option key={member.id} value={member.id}>
                    {member.name}
                  </option>
                ))}
              </select>
            </>
          ) : null}
        </>
      ) : null}
    </>
  );
};

export default IssueResolveFields;
